import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkMark",
  "use": "checkMark-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 14\" id=\"checkMark\"><path d=\"m1.39 7.64 5.37 4.45L14.95 1.9\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol